import styled from 'styled-components';

import { media } from '../../../theme/media';
import { paragraph, inlineLink } from '../../../theme/typography';
import { columnLayout, contentStyles } from '../../../theme/layout';
import { contentPadding } from '../../../theme/mixins';
import { themeSize } from '../../../theme/getters';
import { TextWithLinks } from '../../../shared/components/textWithLinks';

export const Container = styled.div`
  width: 100%;

  ${media.tablet`
    padding-top: 56px;
    ${columnLayout};
    grid-column-gap: 0;
    grid-template-columns: 1fr ${({ hasLocation }) => (hasLocation ? '1fr' : '')};
  `};

  ${media.desktopWide`
    width: ${({ hasLocation }) => (!hasLocation ? 'initial' : '')};
  `}

  ${media.desktopFull`
    ${contentStyles};
  `};
`;

export const MapWrapper = styled.div`
  margin-bottom: 56px;

  ${media.tablet` 
    margin-bottom: 0;
  `};

  ${media.desktopFull`
    padding-left: ${themeSize('contentPadding')}px;
  `};
`;

export const DetailsWrapper = styled.div`
  padding-top: ${({ hasLocation }) => !hasLocation && '32px'};
  text-align: left;
  ${contentPadding};
  max-width: 800px;

  ${media.tablet`
    padding-top: initial;
  `};
`;

export const WhereToGoContent = styled.div`
  display: grid;
  grid-column-gap: 44px;
  grid-template-columns: 1fr;
  ${media.tablet`
    grid-template-columns: 1fr 1fr;
  `};
`;

export const Directions = styled(TextWithLinks)`
  ${paragraph};
  padding-top: 24px;

  ${media.tablet`
    padding-top: 5px;
  `};
`;

export const Text = styled(TextWithLinks)`
  ${paragraph};
`;

export const PolicyInfo = styled.p`
  ${paragraph};
  margin-bottom: 32px;
`;

export const PolicyLink = styled.a`
  ${inlineLink};
  ${paragraph};
`;
